import { useContext } from "react";
import { fileManagerContext } from "../contexts/fileManager";

export const useFileManagerContext = () => {
  const fileManager = useContext(fileManagerContext);
  if (!fileManager) throw new Error('Must be within a FileManagerProvider');
  return fileManager;
};
